export const nyu_valid_email_extensions = [
    'nyu.edu',
    'stern.nyu.edu',
    'tisch.nyu.edu',
    'engineering.nyu.edu',
    'tandon.nyu.edu',
    'steinhardt.nyu.edu',
    'gsas.nyu.edu',
    'wagner.nyu.edu',
    'law.nyu.edu',
    'med.nyu.edu',
    'nyulangone.org',
    'nyuad.nyu.edu',
    'shanghai.nyu.edu',
    'cims.nyu.edu',
    'courant.nyu.edu',
    'cs.nyu.edu',
    'alumni.nyu.edu',
    'library.nyu.edu',
    'view.email.tandon.nyu.edu',
    // Add more emails extensions here
];